<div class="grid-container">
  <div class="header">
    <img alt="MRI " height="80" src="assets/images/favicon.ico" />
    <h3 class="mri-heading mri-heading--3 m-0">{{ title }}</h3>
  </div>
  <div class="content p-3">
    <span class="item-name">Client Version:</span>
    <span class="ps-2 item-value">{{ version }}</span>
  </div>
</div>
